import CtaBtn from '../btn/CtaBtn';
// import MidDivider from './svg/MidDivider';
// import MidDivider from '.././MidDivider';
import  { FooterSeparator } from '../../components/svg/MidDivider';

// import Spiralsvg from './Spiralsvg';
import './radial.css';

const Radial = () => {
  return (
    <div className=" bg-[#D9D9D9]">
      <div className="flex flex-col justify-center items-center bg-[#2a2a2a] h-[400px] relative ">
        <svg
          className="svg-radial"
          width="450"
          height="400"
          viewBox="0 0 599 450"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <circle
            cx="60.3397"
            cy="-88.7329"
            r="535.487"
            fill="url(#pattern0)"
          />
          <circle cx="60.3397" cy="-88.7329" r="535.487" fill="#262626" />
          <circle
            cx="60.3397"
            cy="-88.7329"
            r="535.487"
            stroke="#2f2f2f"
            strokeWidth="5"
          />
          <path
            d="M511.56 -88.7339C511.56 160.464 309.316 362.484 59.8286 362.484C-189.658 362.484 -391.903 160.464 -391.903 -88.7339C-391.903 -337.932 -189.658 -539.952 59.8286 -539.952C309.316 -539.952 511.56 -337.932 511.56 -88.7339Z"
            fill="url(#pattern1)"
          />
          <path
            d="M511.56 -88.7339C511.56 160.464 309.316 362.484 59.8286 362.484C-189.658 362.484 -391.903 160.464 -391.903 -88.7339C-391.903 -337.932 -189.658 -539.952 59.8286 -539.952C309.316 -539.952 511.56 -337.932 511.56 -88.7339Z"
            fill="#262626"
          />
          <path
            d="M511.56 -88.7339C511.56 160.464 309.316 362.484 59.8286 362.484C-189.658 362.484 -391.903 160.464 -391.903 -88.7339C-391.903 -337.932 -189.658 -539.952 59.8286 -539.952C309.316 -539.952 511.56 -337.932 511.56 -88.7339Z"
            stroke="#2f2f2f"
            strokeWidth="5"
          />
          <path
            d="M438.589 -88.7318C438.589 120.742 269.006 290.549 59.8221 290.549C-149.362 290.549 -318.945 120.742 -318.945 -88.7318C-318.945 -298.206 -149.362 -468.012 59.8221 -468.012C269.006 -468.012 438.589 -298.206 438.589 -88.7318Z"
            fill="url(#pattern2)"
          />
          <path
            d="M438.589 -88.7318C438.589 120.742 269.006 290.549 59.8221 290.549C-149.362 290.549 -318.945 120.742 -318.945 -88.7318C-318.945 -298.206 -149.362 -468.012 59.8221 -468.012C269.006 -468.012 438.589 -298.206 438.589 -88.7318Z"
            fill="#262626"
          />
          <path
            d="M438.589 -88.7318C438.589 120.742 269.006 290.549 59.8221 290.549C-149.362 290.549 -318.945 120.742 -318.945 -88.7318C-318.945 -298.206 -149.362 -468.012 59.8221 -468.012C269.006 -468.012 438.589 -298.206 438.589 -88.7318Z"
            stroke="#2f2f2f"
            strokeWidth="5"
          />
          <circle
            cx="60.3399"
            cy="-87.7065"
            r="321.731"
            fill="url(#pattern3)"
          />
          <circle cx="60.3399" cy="-87.7065" r="321.731" fill="#262626" />
          <circle
            cx="60.3399"
            cy="-87.7065"
            r="321.731"
            stroke="#2f2f2f"
            strokeWidth="5"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_1757_495" transform="scale(0.015625)" />
            </pattern>
            <pattern
              id="pattern1"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_1757_495"
                transform="matrix(0.015625 0 0 0.0156427 0 -0.000566272)"
              />
            </pattern>
            <pattern
              id="pattern2"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_1757_495"
                transform="matrix(0.0156461 0 0 0.015625 -0.000673799 0)"
              />
            </pattern>
            <pattern
              id="pattern3"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_1757_495" transform="scale(0.015625)" />
            </pattern>
            <image
              id="image0_1757_495"
              width="64"
              height="64"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAONJREFUeF7t20EOhEAIRFG4/6F7DvEnYeFzryQIv6pBd2behOu9dPvsbog+k+NLgArQAqmJcw9iAAhSgZKB3IJkkAySQTJ4CiE+gA8oBeg0mH3Ai084P89HhqwEqIA209ICsQdjAeaZIgaAYKxBDMCAYy8fXwAIgiAIcoJpJEYGI4VjB3YrbC9gL2AvkCB43cM5PgZgAAZgQFnNZAhdGykQBEEQBEEQDBmgAm2glM/z+QUYisYUGoldO7kY32IEAzCg6RgIRgjFAsw+AgRBMNYgBmCAT2TCYfoPPz/HCqQCX1eBHzHnv7C7WhBSAAAAAElFTkSuQmCC"
            />
          </defs>
        </svg>
        <div className="flex flex-col items-center justify-center gap-6 z-20 p-8  mb-8">
          <h1 className="text-[20px] font-extrabold md:font-bold lg:text-[50px] text-25px font-bold leading-13  text-center text-white">
            Enter <span className='underline'>the future</span> of healthcare distribution with LifeBank
          </h1>
          <p
            className="text-white lg:text-[25px] font-normal text-center w-full"
            style={{ '--text-color': '#F2F2F2' }}
          >
            Book your appointment now and take the first step towards improving
            patient <br className="hidden md:hidden lg:inline"/> outcomes and streamlining your hospital&apos;s operations.
          </p>
          <CtaBtn name="Book Now" />
        </div>
      </div>
        <FooterSeparator/>
      <div className="">
      </div>
    </div>
  );
};

export default Radial;
